import React, { useEffect, useState } from 'react';

export default function Unsubscribe() {
  const token = new URLSearchParams(window.location.search).get('token') || '';
  const [status, setStatus] = useState('loading');
  const [message, setMessage] = useState('Checking your email preference...');

  useEffect(() => {
    if (!token) {
      setStatus('error');
      setMessage('This unsubscribe link is invalid.');
      return;
    }

    fetch(`/api/marketing-unsubscribe/status?token=${encodeURIComponent(token)}`, {
      headers: { Accept: 'application/json' },
    })
      .then(async (response) => {
        const data = await response.json();
        if (!response.ok) throw new Error(data.error || 'Unable to check this link.');
        if (data.marketingOptIn) {
          setStatus('ready');
          setMessage('Stop receiving marketing emails from FantasyBet?');
        } else {
          setStatus('done');
          setMessage('You are already unsubscribed from marketing emails.');
        }
      })
      .catch((error) => {
        setStatus('error');
        setMessage(error.message);
      });
  }, [token]);

  const unsubscribe = async () => {
    setStatus('saving');
    setMessage('Updating your preference...');
    try {
      const response = await fetch('/api/marketing-unsubscribe', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token }),
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.error || 'Unable to unsubscribe.');
      setStatus('done');
      setMessage('You have been unsubscribed from FantasyBet marketing emails.');
    } catch (error) {
      setStatus('error');
      setMessage(error.message);
    }
  };

  return (
    <div className="col-lg-6 col-md-8 col-11 mx-auto mt-5">
      <div className="bg-green text-white rounded shadow-down p-4 text-start">
        <h1 className="h3 mb-3">Marketing emails</h1>
        <p className="mb-4">{message}</p>
        {status === 'ready' && (
          <button className="btn btn-danger fw-bold" onClick={unsubscribe}>
            Unsubscribe
          </button>
        )}
        {status === 'error' && (
          <p className="text-red mb-0">You can also change this in Account Settings after signing in.</p>
        )}
      </div>
    </div>
  );
}
